/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';

/**
 * 
 * @export
 * @interface ContractorListItem
 */
export interface ContractorListItem {
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof ContractorListItem
     */
    id: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof ContractorListItem
     */
    userId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorListItem
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof ContractorListItem
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof ContractorListItem
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof ContractorListItem
     */
    type: string;
    /**
     * 
     * @type {boolean}
     * @memberof ContractorListItem
     */
    hasLogin: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContractorListItem
     */
    archived: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ContractorListItem
     */
    packetSentAt: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ContractorListItem
     */
    createdAt: Date | null;
}

/**
 * Check if a given object implements the ContractorListItem interface.
 */
export function instanceOfContractorListItem(value: object): value is ContractorListItem {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('hasLogin' in value) || value['hasLogin'] === undefined) return false;
    if (!('archived' in value) || value['archived'] === undefined) return false;
    if (!('packetSentAt' in value) || value['packetSentAt'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function ContractorListItemFromJSON(json: any): ContractorListItem {
    return ContractorListItemFromJSONTyped(json, false);
}

export function ContractorListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractorListItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ActorActivityRecordActorUserIdFromJSON(json['id']),
        'userId': ActorActivityRecordActorUserIdFromJSON(json['userId']),
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'email': json['email'],
        'type': json['type'],
        'hasLogin': json['hasLogin'],
        'archived': json['archived'],
        'packetSentAt': (json['packetSentAt'] == null ? null : new Date(json['packetSentAt'])),
        'createdAt': (json['createdAt'] == null ? null : new Date(json['createdAt'])),
    };
}

export function ContractorListItemToJSON(json: any): ContractorListItem {
    return ContractorListItemToJSONTyped(json, false);
}

export function ContractorListItemToJSONTyped(value?: ContractorListItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ActorActivityRecordActorUserIdToJSON(value['id']),
        'userId': ActorActivityRecordActorUserIdToJSON(value['userId']),
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'type': value['type'],
        'hasLogin': value['hasLogin'],
        'archived': value['archived'],
        'packetSentAt': value['packetSentAt'] == null ? value['packetSentAt'] : value['packetSentAt'].toISOString(),
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
    };
}

